var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 22,
    viewBox: "0 0 25 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.9701 6.03223C4.96015 6.03223 3.31836 7.70119 3.31836 9.74441V12.5159C3.31836 14.5591 4.96015 16.2281 6.9701 16.2281H18.9104C20.9203 16.2281 22.5621 14.5591 22.5621 12.5159V9.74441C22.5621 7.70119 20.9203 6.03223 18.9104 6.03223H6.9701ZM20.5721 9.74441V12.5159C20.5721 13.4465 19.8258 14.2051 18.9104 14.2051H6.9701C6.05468 14.2051 5.30841 13.4465 5.30841 12.5159V9.74441C5.30841 8.81384 6.05468 8.05522 6.9701 8.05522H18.9104C19.8258 8.05522 20.5721 8.81384 20.5721 9.74441Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.93497 2.14799H23.9449C24.4922 2.14799 24.9399 1.69282 24.9399 1.13649C24.9399 0.580172 24.4922 0.125 23.9449 0.125H1.93497C1.3877 0.125 0.939941 0.580172 0.939941 1.13649C0.939941 1.69282 1.3877 2.14799 1.93497 2.14799Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9449 20.1016H1.93497C1.3877 20.1016 0.939941 20.5567 0.939941 21.1131C0.939941 21.6694 1.3877 22.1246 1.93497 22.1246H23.9449C24.4922 22.1246 24.9399 21.6694 24.9399 21.1131C24.9399 20.5567 24.4922 20.1016 23.9449 20.1016Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContent);
export default __webpack_public_path__ + "static/media/Content.bb6469979e50ee8de11428900a2fc5c3.svg";
export { ForwardRef as ReactComponent };